import React, { FunctionComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface RevenueGraphProps {
  dailySales: any;
}
export const DailySalesReport: FunctionComponent<RevenueGraphProps> = ({
  dailySales
}) => {
  const changedArray = dailySales.map((item: any) => {
    return { hours: item.s_hour, net_total: item.s_total };
  });
  const max = Math.max.apply(null, changedArray.map((val:any) => val.net_total));

  if (dailySales.length === 0) {
    return <h2>No data to show report!</h2>
  } else {
    return (
      <ResponsiveContainer width={550} height={430}>
        <LineChart
          data={changedArray}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="hours" />
          <YAxis 
            // dataKey="net_total" 
            type="number" domain={[0, max+10]}
          /> 
          <Tooltip />
          <Legend
            margin={{ top: 15, bottom: 15 }}
          />
          <Line type="monotone" dataKey="net_total" stroke="red" activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}


